const DATA_TEST_IDS = {
  fragmentsPermissionsBranch: 'module__lims_permissions-branch',
  fragmentsSelectedPermissionsFragment: 'module__lims_selected-permissions',
  fragmentsTreeFragment: 'module__lims_tree',
  fragmentsTreeList: 'module__lims_tree-list',
  fragmentsSelectionDialogWarning: 'module__lims_selection-dialog-warning',
} as const;

export default DATA_TEST_IDS;
